import { persistor } from "../redux/Store";
import { clearSession } from "../utils/sessionTokens";

/*
 * Logging out from a component. This cleared only the four sessionStorage keys, which left the
 * localStorage copies and `kinesin-isAuthenticated` behind for the next load to restore — see
 * sessionTokens.
 */
export const logoutFromHelper = () => {
  clearSession();
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
};

export var render = function () {

};
